import { useEffect } from "react";
import Body from "./Body";
import SettingStore from "../../../store/Setting/Setting.store";
import StudentApp from "../../../components/PagesComponents/Setting/Accissibility/StudentApp/StudentApp.component";
import StaffApp from "../../../components/PagesComponents/Setting/Accissibility/StaffApp/StaffApp.component";

const Accessibility = () => {
  const { currentTab, setCurrentTab } = SettingStore(); //admininfo,basicinfo,advanceinfo,documentinfo

  const handelCurrentTab = () => {
    if (currentTab === "studentApp") {
      return <StudentApp />;
    } else if (currentTab === "staffApp") {
      return <StaffApp/>
    }
  };

  useEffect(() => {
    setCurrentTab("staffApp");
  }, [setCurrentTab]);
  const _this = { handelCurrentTab, currentTab, setCurrentTab };
  return <Body {..._this} />;
};

export default Accessibility;
